import { render, staticRenderFns } from "./retur-shipment-table.vue?vue&type=template&id=2482add4&"
import script from "./retur-shipment-table.vue?vue&type=script&lang=js&"
export * from "./retur-shipment-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports